import { toast } from "sonner";

// Mostra o erro da API; se o caixa estiver fechado (HTTP 423) oferece atalho para abrir o caixa
export const toastApiError = (err, fallback = "Ocorreu um erro") => {
  const d = err?.response?.data?.detail;
  const msg = typeof d === "string" ? d : d?.message || fallback;
  if (err?.response?.status === 423) {
    toast.error(msg, {
      duration: 8000,
      action: { label: "Abrir Caixa", onClick: () => window.location.assign("/cash") },
    });
    return;
  }
  toast.error(msg);
};
